<template>

    <SubHeader title="Enregistrer un dossier reçu par courrier"
        :breads="[{ name: 'Nouveau dossier' }, { name: 'Courrier' }]" :action="{}" />

    <Modal @handle-submit="this.toggleModal = false">

        <div class="row">
            <template v-for="(fill, i) in data.files_result" :key="i">

                <div class="col-lg-6 align-items-center mt-2" v-if="fill">
                    <div class="row align-items-center">
                        <div class="col-lg-2 ">
                            <img :src="fill.url" v-if="fill.is_img" alt="" style="width: 70px;height: 70px">

                            <i class="bi bi-file-earmark" style="font-size: 40px;" v-else></i>
                        </div>
                        <div class="col-lg-10">
                            <div class="mb-3">
                                <label class="form-label" for="firstname">Nom du fichier</label>
                                <input type="text" name="firstname" id="firstname" class="form-control"
                                    placeholder="Nom du fichier" v-model="fill.name" value="">
                            </div>
                        </div>
                    </div>
                </div>
            </template>

        </div>
        <template #btn>

            <button type="button" class="btn btn-primary" @click="this.toggleModal = false">

                <span>
                    Enregistrer
                </span>
            </button>


        </template>
    </Modal>
    <form >

        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12 mt-2">
                        <div class="card" v-if="courrierIsLoading">
                            <div class="card-body">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-else>
                            <div class="card-header card-header-content-md-between bold">
                                Détails principaux de la plainte / dénonciation
                            </div>
                            <div class="card-body">

                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="category">Canal <span
                                            class="required">*</span></label>

                                    <m-select v-model="data.category" :loading="categoryIsLoading" :allow-empty="false"
                                        :required="true" :options="categorySubCategory" :searchable="false"
                                        placeholder="Canal" track-by="id" label="label" :close-on-select="true">
                                    </m-select>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label" for="subject">Sujet <span
                                            class="required">*</span></label>
                                    <input required type="text" name="subject" v-model="data.subject" id="subject"
                                        class="form-control" placeholder="Objet de la plainte">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="description">Description <span
                                            class="required">*</span></label>
                                    <textarea required name="description" v-model="data.description" id="description"
                                        class="form-control" placeholder="Description de la plainte / dénonciation"
                                        rows="6"></textarea>
                                </div>

                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="institution">Organisme concerné <span
                                            class="required">*</span></label>
                                    <m-select v-model="data.institution" :loading="institutionIsLoading"
                                        :required="!createNewInstitution" :allowEmpty="false" :options="institutionItems"
                                        :searchable="true" placeholder="Liste des organisme" track-by="id"
                                        label="label" :close-on-select="true">
                                    </m-select>
                                    <small class="text-muted">
                                        <i class="bi bi-info-circle me-1"></i>
                                        Si vous ne trouvez pas l'institution, cochez la case ci-dessous pour en créer une nouvelle.
                                    </small>
                                </div>

                                <div class="mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="createNewInstitution"
                                            v-model="createNewInstitution" @change="resetInstitutionSelection">
                                        <label class="form-check-label fw-bold text-primary" for="createNewInstitution">
                                            <i class="bi bi-plus-circle me-1"></i>
                                            Créer une nouvelle institution
                                        </label>
                                    </div>
                                </div>

                                <div v-if="createNewInstitution" class="card border-primary mb-3">
                                    <div class="card-header bg-primary text-white">
                                        <h6 class="mb-0">🏢 Nouvelle Institution</h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <label class="form-label" for="new_institution_label">Nom de l'institution *</label>
                                            <input type="text" class="form-control" id="new_institution_label"
                                                v-model="newInstitutionData.label"
                                                placeholder="Ex: Ministère de la Santé"
                                                :required="createNewInstitution">
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="new_institution_email">Email</label>
                                                    <input type="email" class="form-control" id="new_institution_email"
                                                        v-model="newInstitutionData.email"
                                                        placeholder="contact@institution.bj">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="new_institution_phone">Téléphone</label>
                                                    <input type="text" class="form-control" id="new_institution_phone"
                                                        v-model="newInstitutionData.phone"
                                                        placeholder="+229 XX XX XX XX">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label text-muted" for="new_institution_type">Type d'institution (optionnel)</label>
                                            <select class="form-select" id="new_institution_type" v-model="newInstitutionData.type">
                                                <option :value="null">Non spécifié</option>
                                                <option v-for="type in institutiontypeItems" :key="type.id" :value="type.id">
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="d-grid gap-2">
                                            <button type="button" class="btn btn-success"
                                                @click="createNewInstitutionOnly"
                                                :disabled="!newInstitutionData.label || creatingInstitution">
                                                <span v-if="creatingInstitution">
                                                    <span class="spinner-border spinner-border-sm me-2"></span>
                                                    Création en cours...
                                                </span>
                                                <span v-else>
                                                    <i class="bi bi-plus-circle me-2"></i>
                                                    Créer l'institution
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label" for="fichiers">Ajouter des fichiers (20Mo)</label>

                                    <drop-files v-model="data.files" :multiple="true" previewWrapperClasses="row"
                                        selectFileStrategy="merge" :maxFiles="15">
                                        <template #title>
                                            <h3><b>Glissez-déposez les fichiers
                                                </b></h3>
                                        </template>
                                        <template #button="{ fileInput }">
                                            <u @click="fileInput?.click()">
                                                Ou Cliquez ici
                                            </u>
                                        </template>
                                        <template #description>
                                            <div>
                                                Les fichiers ne doiventpas dépasser 20Mo
                                            </div>
                                        </template>

                                    </drop-files>
                                </div>


                            </div>
                        </div>

                    </div>
                    <div class="col-md-12 mt-2">
                        <div class="card" v-if="courrierIsLoading">
                            <div class="card-body">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-else>
                            <div class="card-header card-header-content-md-between bold">
                                Identité du plaignant
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-control" for="anonym">
                                        <span class="form-check">
                                            <input type="checkbox" class="form-check-input" v-model="data.anonym"
                                                name="anonym" id="anonym">
                                            <span class="form-check-label">Déclaration sous anonymat</span>
                                        </span>
                                    </label>
                                </div>
                                <template v-if="!data.anonym">

                                    <div class="mb-3">
                                        <label class="form-label" for="lastname">Nom</label>
                                        <input type="text" v-model="data.lastname" name="lastname" id="lastname"
                                            class="form-control" placeholder="Nom">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="firstname">Prénom(s)</label>
                                        <input type="text" v-model="data.firstname" name="firstname" id="firstname"
                                            class="form-control" placeholder="Prénoms">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="phone">Téléphone</label>
                                        <input type="text" name="phone" id="phone" class="form-control"
                                            placeholder="Numéro de téléphone" v-model="data.phone">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="email">Email</label>
                                        <input type="text" name="email" id="email" v-model="data.email"
                                            class="form-control" placeholder="Email">
                                    </div>

                                    <div class="mb-3 tom-select-custom">
                                        <label class="form-label" for="complainer">Qualité du plaignant</label>
                                        <m-select v-model="data.complainer" :loading="complainerIsLoading"
                                            :required="true" :allowEmpty="false" :options="complainerItems"
                                            :searchable="false" placeholder="Qualite du plaignant" track-by="id"
                                            label="label" :close-on-select="true">
                                        </m-select>
                                    </div>
                                </template>


                            </div>
                            <!-- div class="card-footer"></div -->
                        </div>

                    </div>



                </div>
            </div>
            <div class="col-md-6">
                <div class="row">

                    <div class="col-md-12 mt-2">
                        <div class="card" v-if="courrierIsLoading">
                            <div class="card-body">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-else>
                            <div class="card-header card-header-content-md-between bold">
                                Caractérisation de la plainte / dénonciation
                            </div>
                            <div class="card-body">


                                <div class="mb-3 tom-select-custom" v-for="(categ, i) in caracterisationItems" :key="i">
                                    <template v-if="categ.filled_by_human">
                                    <label class="form-label" :for="categ.name">{{ categ.name }}</label>
                                    <div v-if="categ.type == 'Zone de texte'">
                                        <input type="text" :name="categ.name" :id="categ.name" class="form-control"
                                            :placeholder="categ.name" v-model="data.caracterisations[categ.id]"
                                            value="">
                                    </div>
                                    <m-select v-else v-model="data.caracterisations[categ.id]"
                                        :loading="caracterisationIsLoading" :required="true" :options="categ.elements"
                                        :searchable="true" :multiple="categ.type == 'Choix multiple'"
                                        :placeholder="'Liste des ' + categ.name" track-by="id" label="name"
                                        :close-on-select="true">
                                    </m-select>
                                    </template>
                                </div>


                            </div>
                            <!-- div class="card-footer"></div -->
                        </div>

                    </div>
                    <div class="col-md-12 mt-2">
                        <div class="card" v-if="courrierIsLoading">
                            <div class="card-body">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-else>
                            <div class="card-header card-header-content-md-between bold">
                                Information sur la réception
                            </div>
                            <div class="card-body">
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="service">Service</label>
                                    <m-select v-model="data.service" :loading="serviceIsLoading" :required="true"
                                        :options="serviceItems" :allowEmpty="false" :searchable="false"
                                        placeholder="Service" track-by="id" label="label" :close-on-select="true">
                                    </m-select>
                                </div>

                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="recipient">Agent</label>
                                    <m-select v-model="data.agent" :loading="serviceIsLoading" :required="true"
                                        :options="agentItemsFilt" :allowEmpty="false" :searchable="false"
                                        placeholder="Agents" track-by="id" label="firstname" :close-on-select="true">
                                    </m-select>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>




        </div>
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <button type="button" @click="prepareBeforeSubmit" class="btn btn-primary ">Enregistrer</button>
                        <button type="reset" class="btn btn-outline-primary mx-3">Annuler</button>
                    </div>
                </div>
            </div>
        </div>

    </form>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Modal from "@/widgets/Modal.vue"
import notify from "@/utils/notify.js"
import backend from "@/utils/backend"


export default {
    name: "DossierNewCourrier",
    components: {
        SubHeader,
        Modal
    },
    data() {
        return {
            data: {
                caracterisations: {},
                files: [],
                files_result: [],
                anonym: false,
                institution_id:null,
                complaintsubcategory_id:null,
            },
            agentItemsFilt: [],
            acceptData: [""],
            createNewInstitution: false,
            creatingInstitution: false,
            newInstitutionData: {
                label: '',
                email: '',
                phone: '',
                type: null
            },
            institutiontypeItems: [],
            institutiontypeIsLoading: false,
        }
    },

    computed: {
        ...mapFields("widget/modal", {
            toggleModal: 'showMessage'
        }),
        ...mapFields("dossier/create", {
            courrierIsLoading: "isLoading",
            courrierIsSuccess: "isSuccess",
            courrierShowMessage: "showMessage",
            courrierMessage: "message",
            courrierIsCreated: "isCreated",
            courrierItem: "created"
        }),

        ...mapFields("institution/list", {
            institutionIsLoading: "isLoading",
            institutionIsSuccess: "isSuccess",
            institutionShowMessage: "showMessage",
            institutionMessage: "message",
            institutionItems: "items"

        }),
        ...mapFields("category/show", {

            categoryIsLoading: "isLoading",
            categoryIsSuccess: "isSuccess",
            categoryShowMessage: "showMessage",
            categoryMessage: "message",
            categorySubCategory: "subcategory",
            categoryItem: "items"

        }),
        ...mapFields("service/list", {
            serviceIsLoading: "isLoading",
            serviceIsSuccess: "isSuccess",
            serviceShowMessage: "showMessage",
            serviceMessage: "message",
            serviceItems: "items"

        }),
        ...mapFields("agent/list", {
            agentIsLoading: "isLoading",
            agentIsSuccess: "isSuccess",
            agentShowMessage: "showMessage",
            agentMessage: "message",
            agentItems: "items"

        }),
        ...mapFields("complainer/list", {
            complainerIsLoading: "isLoading",
            complainerIsSuccess: "isSuccess",
            complainerShowMessage: "showMessage",
            complainerMessage: "message",
            complainerItems: "items"

        }),
        ...mapFields("caracterisation/list", {
            caracterisationIsLoading: "isLoading",
            caracterisationIsSuccess: "isSuccess",
            caracterisationShowMessage: "showMessage",
            caracterisationMessage: "message",
            caracterisationItems: "items"

        }),
    },
    watch: {
        "data.files"(newVal, oldVal) {
            this.data.files_result = []
            if (newVal.length > oldVal.length) {

                this.toggleModal = true
            }

            newVal.forEach((file, i) => {
                const fil_name_split = file.file.name.split(".")

                file.name = file.name ?? fil_name_split[0] ?? `Fichier_${i}`;
                file.is_img = file.file.type.includes("image")
                if (file.is_img) {

                    file.url = URL.createObjectURL(file.file)
                }

                this.data.files_result.push(file);

            });
        },

        courrierIsCreated(val) {
            if (this.courrierItem && val) {
                notify(`<div class="ml-2" style="margin-left:10px"><b>Super,La plainte a été énregistrée</b><a href="/dossier/${this.courrierItem.id ?? 0}/show" target="_blank" class="badge bg-soft-primary text-primary ">Consulter</a></div>`)

                this.data = {
                    caracterisations: {},
                    files: [],
                    files_result: [],
                    anonym: false,
                }
            }
        },

        categorySubCategory(val) {
            if (val.length > 0) {
                this.data.category = val[0]
            }
        },
        "data.category"(val) {
            this.data.complaintsubcategory_id = val?.id ?? null
        },
        institutionItems(val) {
            if (val.length > 0) {
                this.data.institution = val[0]
            }
        },
        "data.institution"(val) {
            this.data.institution_id = val?.id ?? null
        },
        complainerItems(val) {
            if (val.length > 0) {
                this.data.complainer = val[0]
            }
        },
        "data.complainer"(val) {
            this.data.complainer_id = val?.id ?? null
        },
        serviceItems(val) {
            if (val.length > 0) {
                this.data.service = val[0]
            }
        },
        "data.service"(val) {
            this.data.service_id = val?.id ?? null
            this.agentItemsFilt = this.agentItems.filter((s) => s.recipientservice_id == val?.id);
            // this.data.agent = {}
        },
        agentItems() {
            if (this.data.service_id) {
                this.agentItemsFilt = this.agentItems.filter((s) => s.recipientservice_id == this.data.service_id);
            }
        },
        agentItemsFilt(val) {
            if (val.length > 0) {
                this.data.agent = val[0]
            } else {
                this.data.agent = null;
            }
        },
        "data.agent"(val) {
            this.data.recipient_id = val?.id ?? null


        }
    },

    methods: {
        ...mapActions({
            handleSubmit: "dossier/create/createPlainte",
            resetCourrier: "dossier/create/resetData",
            getInstitutions: "institution/list/getAll",
            resetInstitutions: "institution/list/resetData",
            getServices: "service/list/getAll",
            resetServices: "service/list/resetData",
            getAgents: "agent/list/getAll",
            resetAgents: "agent/list/resetData",
            getCategorys: "category/show/getOne",
            resetCategorys: "category/show/resetData",
            getComplainers: "complainer/list/getAll",
            resetComplainers: "complainer/list/resetData",
            getCaracterisations: "caracterisation/list/getAll",
            resetCaracterisations: "caracterisation/list/resetData",
        }),
        prepareBeforeSubmit() {
            if(this.data.description == null || this.data.description?.trim() == "" || this.data.subject ==null || this.data.subject?.trim() == "" || this.data.institution_id == null || this.data.complaintsubcategory_id ==null){
               notify("Veuillez remplir les champs obligatoires", "error")
                return
            }
            const currentData = { ...this.data };

            delete currentData?.category
            delete currentData?.service
            delete currentData?.complainer
            delete currentData?.institution
            delete currentData?.agent
            delete currentData?.files_result

            currentData.insights = {};
            
            if (currentData.caracterisations) {
                
                const insights_keys = Object.keys(currentData.caracterisations); 
                insights_keys?.forEach((key) => {
                    let values = currentData.caracterisations[key]
                    if (typeof (values) == Array) {
                        currentData.insights[key] = values.map(({ id }) => id)
                    } else {
                        currentData.insights[key] = [values.id]

                    }
                })
            }




            delete currentData.files
            delete currentData.caracterisations

            currentData.documents = this.data.files_result

            this.handleSubmit(currentData);


        },

        async getInstitutionTypes() {
            this.institutiontypeIsLoading = true
            try {
                const response = await backend({ method: 'GET', url: '/institution-type' })
                this.institutiontypeItems = response.data.data || []
            } catch (error) {
                console.error('Erreur lors du chargement des types d\'institutions:', error)
                this.institutiontypeItems = []
            } finally {
                this.institutiontypeIsLoading = false
            }
        },

        resetInstitutionSelection() {
            if (this.createNewInstitution) {
                // Vider la sélection d'institution existante
                this.data.institution = null
                this.data.institution_id = null
            }
        },

        async createNewInstitutionOnly() {
            if (!this.newInstitutionData.label) {
                notify('Le nom de l\'institution est obligatoire', 'error')
                return
            }

            this.creatingInstitution = true
            try {
                // Créer l'institution via l'API
                const data = {
                    label: this.newInstitutionData.label,
                    institutiontype_id: this.newInstitutionData.type || null,
                    email: this.newInstitutionData.email || null,
                    phone: this.newInstitutionData.phone || null,
                }

                await backend({
                    method: 'POST',
                    url: '/institutions',
                    data
                })

                // Succès
                notify(`Institution "${this.newInstitutionData.label}" créée avec succès !`, 'success')

                // Réinitialiser le formulaire
                this.newInstitutionData = {
                    label: '',
                    email: '',
                    phone: '',
                    type: null
                }
                this.createNewInstitution = false

                // Rafraîchir la liste des institutions
                await this.getInstitutions()

                // Afficher un message pour demander de sélectionner
                setTimeout(() => {
                    notify('✅ Institution ajoutée ! Sélectionnez-la maintenant dans la liste.', 'info')
                }, 500)

            } catch (error) {
                console.error('Erreur lors de la création de l\'institution:', error)
                const errorMsg = error.response?.data?.message || 'Impossible de créer cette institution'
                notify(errorMsg, 'error')
            } finally {
                this.creatingInstitution = false
            }
        }
    },
    mounted() {

        this.getCaracterisations()
        this.getInstitutions()
        this.getAgents()
        this.getServices()
        this.getCategorys(3)
        this.getComplainers()
        this.getInstitutionTypes()
    },
    unmounted() {
        this.resetCourrier()
        this.resetInstitutions()
        this.resetServices()
        this.resetAgents()
        this.resetCategorys()
        this.resetComplainers()
    }




}
</script>